import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const d=l("niue",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92886)">
                <path
                    d="M24.0003 4.5L24.0003 20.5L-0.000488281 20.5L-0.000488281 4.5L24.0003 4.5Z"
                    fill="#FEDD00" />
                <path
                    d="M17.3901 4.5L-0.000488281 4.5L-0.000488281 13.4433L17.3901 13.4433V4.5Z"
                    fill="#012169" />
                <path
                    d="M-0.000488281 5.49867L3.85152 7.48111H-0.000488281L-0.000488281 10.4622H3.85152L-0.000488281 12.4447L-0.000488281 13.4433H1.94436L7.24558 10.7156L7.24558 13.4433H10.144V10.7156L15.4452 13.4433L17.3901 13.4433V12.4447L13.5381 10.4622L17.3901 10.4622V7.48111L13.5989 7.4513L17.3901 5.49867V4.5H15.4452L10.144 7.22772V4.5L7.24558 4.5L7.25138 7.23666L1.94436 4.5H-0.000488281L-0.000488281 5.49867Z"
                    fill="white" />
                <path
                    d="M1.29511 13.444L7.09197 10.4629H5.79637L-0.000488281 13.444H1.29511Z"
                    fill="#C8102E" />
                <path
                    d="M4.50077 7.48111H5.79637L-0.000488281 4.5L-0.000488281 5.16777L4.50077 7.48111Z"
                    fill="#C8102E" />
                <path
                    d="M10.2964 7.48111H11.592L17.3888 4.5L16.0932 4.5L10.2964 7.48111Z"
                    fill="#C8102E" />
                <path
                    d="M17.3901 13.444L11.5933 10.4629H12.8889L17.3901 12.7762V13.444Z"
                    fill="#C8102E" />
                <path
                    d="M-0.000488281 8.07733L7.82527 8.07733L7.82527 4.5L9.56432 4.5V8.07733L17.3901 8.07733V9.866L9.56432 9.866L9.56432 13.4433H7.82527L7.82527 9.866H-0.000488281L-0.000488281 8.07733Z"
                    fill="#C8102E" />
                <path
                    d="M8.69646 10.4919C9.51285 10.4919 10.1747 9.81121 10.1747 8.97154C10.1747 8.13186 9.51285 7.45117 8.69646 7.45117C7.88007 7.45117 7.21826 8.13186 7.21826 8.97154C7.21826 9.81121 7.88007 10.4919 8.69646 10.4919Z"
                    fill="#012169" />
                <path
                    d="M9.23052 9.14948L10.1 8.4996H9.02763L8.69431 7.44727L8.36099 8.4996H7.28857L8.1581 9.14948L7.82478 10.2018L8.69431 9.55193L9.56384 10.2018L9.23052 9.14948Z"
                    fill="#FEDD00" />
                <path
                    d="M3.93837 9.16078L4.44849 8.7792H3.81663L3.62244 8.16211L3.42824 8.7792H2.79639L3.30651 9.16078L3.11232 9.77787L3.62244 9.39629L4.13256 9.77787L3.93837 9.16078Z"
                    fill="#FEDD00" />
                <path
                    d="M14.0829 9.16078L14.593 8.7792H13.9612L13.767 8.16211L13.5728 8.7792H12.9409L13.451 9.16078L13.2568 9.77787L13.767 9.39629L14.2771 9.77787L14.0829 9.16078Z"
                    fill="#FEDD00" />
                <path
                    d="M9.00868 12.1432L9.5188 11.7616H8.88695L8.69275 11.1445L8.49856 11.7616H7.8667L8.37682 12.1432L8.18263 12.7603L8.69275 12.3787L9.20287 12.7603L9.00868 12.1432Z"
                    fill="#FEDD00" />
                <path
                    d="M9.00868 6.18031L9.5188 5.79873H8.88695L8.69275 5.18164L8.49856 5.79873H7.8667L8.37682 6.18031L8.18263 6.7974L8.69275 6.41582L9.20287 6.7974L9.00868 6.18031Z"
                    fill="#FEDD00" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92886">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    `),H=l("niue_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92885)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M24 0.5L24 24.5L0 24.5L0 0.5L24 0.5Z"
                    fill="#FEDD00" />
                <path
                    d="M15.7878 0.5L-8.29688 0.5L-8.29688 12.5423L15.7878 12.5423L15.7878 0.5Z"
                    fill="#012169" />
                <path
                    d="M-8.29688 1.84473L-2.96212 4.51411L-8.29688 4.51411L-8.29688 8.52822H-2.96212L-8.29688 11.1976V12.5423H-5.60341L1.73841 8.86942V12.5423H5.75252V8.86942L13.0943 12.5423H15.7878L15.7878 11.1976L10.453 8.52822H15.7878V4.51411L10.5373 4.47397L15.7878 1.84473V0.5L13.0943 0.5L5.75252 4.17291V0.5L1.73841 0.5L1.74643 4.18496L-5.60341 0.5L-8.29688 0.5V1.84473Z"
                    fill="white" />
                <path
                    d="M-6.50257 12.5424L1.52566 8.52832H-0.268648L-8.29688 12.5424H-6.50257Z"
                    fill="#C8102E" />
                <path
                    d="M5.96484 4.51411H7.75915L15.7874 0.5L13.9931 0.5L5.96484 4.51411Z"
                    fill="#C8102E" />
                <path
                    d="M15.786 12.5424L7.75781 8.52832H9.55212L15.786 11.6433V12.5424Z"
                    fill="#C8102E" />
                <path
                    d="M-8.29688 5.31693L2.54123 5.31693V0.5L4.9497 0.5V5.31693L15.7878 5.31693V7.7254L4.9497 7.7254V12.5423H2.54123V7.7254L-8.29688 7.7254L-8.29688 5.31693Z"
                    fill="#C8102E" />
                <path
                    d="M3.74642 8.569C4.87705 8.569 5.79361 7.65244 5.79361 6.52181C5.79361 5.39117 4.87705 4.47461 3.74642 4.47461C2.61578 4.47461 1.69922 5.39117 1.69922 6.52181C1.69922 7.65244 2.61578 8.569 3.74642 8.569Z"
                    fill="#012169" />
                <path
                    d="M4.48633 6.76276L5.69056 5.88768L4.20534 5.88768L3.74372 4.4707L3.2821 5.88768H1.79687L3.00111 6.76276L2.53949 8.17974L3.74372 7.30467L4.94795 8.17974L4.48633 6.76276Z"
                    fill="#FEDD00" />
                <path
                    d="M11.2105 6.77832L11.9169 6.26451H11.0419L10.7729 5.43359L10.504 6.26451H9.62891L10.3354 6.77832L10.0664 7.60924L10.7729 7.09544L11.4794 7.60924L11.2105 6.77832Z"
                    fill="#FEDD00" />
                <path
                    d="M4.18312 10.793L4.88961 10.2792H4.01453L3.74558 9.44824L3.47664 10.2792H2.60156L3.30805 10.793L3.0391 11.6239L3.74558 11.1101L4.45207 11.6239L4.18312 10.793Z"
                    fill="#FEDD00" />
                <path
                    d="M4.18312 2.76465L4.88961 2.25084L4.01453 2.25084L3.74558 1.41992L3.47664 2.25084H2.60156L3.30805 2.76465L3.0391 3.59557L3.74558 3.08176L4.45207 3.59557L4.18312 2.76465Z"
                    fill="#FEDD00" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92885">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{d as Niue,H as NiueRounded};
